var $ = require('jquery');
var TorsoModel = require('backbone-torso/modules/Model');
var portalBarcodeAuthenticationExtService = require('./../../urls').portalBarcodeAuthenticationExtService;
var portalCreateFailedVisitForAuthenticationExtService = require('./../../urls').portalCreateFailedVisitForAuthenticationExtService;

/**
 * Model used to authenticate an ereg user by barcode data + security question form.
 *
 * @class EregAuthBarcodeModel
 * @constructor
 */
module.exports = TorsoModel.extend({
  urlRoot: portalBarcodeAuthenticationExtService,

  /**
   * @method save
   * @override
   * Throws a not implemented error if called. Use authenticate instead
   */
  save: function() {
    throw 'Save not implemented, use EregAuthBarcodeModel.authenticate';
  },

  /**
   * Attempts to authenticate the portal user.
   * This method is extracted from the standard backbone save() because it is not
   * following the methodology of saving an instance of an object on the server, rather it
   * is just checking the validity of the data.
   * Separating this allows us to use the server response without having to go through the model.
   *
   * @method authenticate
   */
  authenticate: function() {
    return $.ajax({
      url: this.urlRoot,
      contentType: 'application/json',
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(this.toJSON())
    });
  },

  createFailedVisit: function() {
    return $.ajax({
      url: portalCreateFailedVisitForAuthenticationExtService,
      contentType: 'application/json',
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(this.toJSON())
    });
  }
});
